// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"styles_closeIcon__2DqBW","container":"styles_container__7K_7E"};